export default __webpack_public_path__ + "static/media/aryan_photo - Aryan Kushan.df7ef808.jpg";